import { PerformanceAudienceKpi } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { KPI_CONFIG } from './kpiConfig';

type PerformanceAudienceKpiRowProps = {
  kpis: PerformanceAudienceKpi[];
};

export const PerformanceAudienceKpiRow: FC<PerformanceAudienceKpiRowProps> = ({ kpis }) => {
  const { t } = useTranslation('performanceAudience');

  return (
    <div className='mb-0 grid grid-cols-2 gap-[18px] xl:grid-cols-4'>
      {kpis.map((kpi) => {
        const config = KPI_CONFIG[kpi.id];
        if (!config) {
          return null;
        }

        const breakdown = kpi.breakdown;

        return (
          <div key={kpi.id} className='rounded-[14px] border border-ink-150 bg-white px-5 py-[18px]'>
            <div className='mb-2.5 flex items-center justify-between text-xs font-medium text-ink-600'>
              <span>{t(config.titleKey)}</span>
              {kpi.badge === 'meta_only' && config.badgeKey ? (
                <span className='rounded border border-ink-200 bg-white px-1.5 py-0.5 text-[10px] uppercase tracking-[0.06em] text-ink-500'>
                  {t(config.badgeKey)}
                </span>
              ) : null}
            </div>
            <div className='text-[30px] font-bold leading-none tracking-[-0.02em] text-brand-600 tabular-nums'>{kpi.value}</div>
            <div className={`flex gap-3 text-[11.5px] text-ink-600 ${breakdown ? 'mt-2' : 'mt-2.5'}`}>{t(config.subtitleKey)}</div>
            {breakdown ? (
              <div className='mt-2.5 flex gap-3 text-[11.5px] text-ink-600'>
                <span>
                  <span className='mr-1.5 inline-block size-[7px] rounded-sm bg-brand-600 align-[1px]' />
                  {breakdown.googleLabel}&nbsp;<b className='font-semibold text-ink-900'>{breakdown.googleValue}</b>
                </span>
                <span>
                  <span className='mr-1.5 inline-block size-[7px] rounded-sm bg-ink-900 align-[1px]' />
                  {breakdown.metaLabel}&nbsp;<b className='font-semibold text-ink-900'>{breakdown.metaValue}</b>
                </span>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
